import React, { useState, useEffect } from 'react';
import { format, startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval, isSameDay, isSameMonth } from 'date-fns';
import axios from 'axios';
import { BASE_URL } from '../Component/Baseurl';
import { ChevronLeft, ChevronRight } from "react-feather";
import ProfileNavbar from '../Component/ProfileNavbar';
import NavbarVisitor from '../Component/NavbarVisitor';

const EventCalander = () => {
  const visitorId = localStorage.getItem("visitor_id");
  const [currentDate, setCurrentDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${BASE_URL}submitedformByVisitorId/${visitorId}`);
        setEvents(response.data.exhibitions || []);
      } catch (err) {
        setError(err.message || "Failed to fetch events.");
      } finally {
        setLoading(false);
      }
    };

    if (visitorId) {
      fetchEvents();
    }
  }, [visitorId]);

  const startDate = startOfMonth(currentDate);
  const endDate = endOfMonth(currentDate);
  const startWeek = startOfWeek(startDate);
  const endWeek = endOfWeek(endDate);
  const daysInMonth = eachDayOfInterval({ start: startWeek, end: endWeek });

  const handlePrevMonth = () => {
    setCurrentDate((prev) => new Date(prev.setMonth(prev.getMonth() - 1)));
  };

  const handleNextMonth = () => {
    setCurrentDate((prev) => new Date(prev.setMonth(prev.getMonth() + 1)));
  };

  const isEventOnDate = (date) => {
    return events.some(event => isSameDay(new Date(event.exhibition_start_date), date));
  };

  const getNextEvent = () => {
    return events.find(event => new Date(event.exhibition_start_date) > new Date()) || null;
  };

  const handleDateClick = (date) => {
    const clickedEvent = events.find(event => isSameDay(new Date(event.exhibition_start_date), date));
    if (clickedEvent) {
      setSelectedEvent(clickedEvent);
    }
  };

  const nextEvent = getNextEvent();

  return (
    <>
      <NavbarVisitor />
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <ProfileNavbar />
            </div>
            <div className="col-md-9">
              <div className="text-start">
                <h2 className="text-start hedng">Event Calendar</h2>
              </div>

              <div className="container mt-4">
                <div className="row">
                  <div className="">
                    <div className="row g-0 mt-2 ro1">
                      <div className="col-md-4 bg11 py-3 px-2">
                        {selectedEvent || nextEvent ? (
                          <div>
                            <div className="upc1 text-white"><strong>Upcoming Event</strong></div>
                            <div className="upc2">
                              {format(new Date((selectedEvent || nextEvent).exhibition_start_date), 'd')}
                              <span className="upc3">{format(new Date((selectedEvent || nextEvent).exhibition_start_date), 'MMM, yyyy')}</span>
                            </div>
                            <div className="upc4">{format(new Date((selectedEvent || nextEvent).exhibition_start_date), 'EEEE')}</div>
                            <div className="upc5">{(selectedEvent || nextEvent).exhibition_name}</div>
                            <div className="upc6">Start Date: {format(new Date((selectedEvent || nextEvent).exhibition_start_date), 'MMMM dd, yyyy')}</div>
                            <div className="upc6">End Date: {format(new Date((selectedEvent || nextEvent).exhibition_end_date), 'MMMM dd, yyyy')}</div>
                          </div>
                        ) : (
                          <div>No upcoming events.</div>
                        )}
                      </div>

                      <div className="col-md-8">
                        <div className="calendar-container">
                          <div className="calendar-header">
                            <button className="clanderbtn" onClick={handlePrevMonth}><ChevronLeft className="text-dark" size={20} /></button>
                            <h2 className="upc1 text-white">{format(currentDate, 'MMMM yyyy')}</h2>
                            <button className="clanderbtn" onClick={handleNextMonth}><ChevronRight className="text-dark" size={20} /></button>
                          </div>

                          <div className="calendar-weekdays">
                            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                              <div key={day} className="calendar-weekday">
                                {day}
                              </div>
                            ))}
                          </div>

                          <div className="calendar-days">
                            {daysInMonth.map((date) => {
                              const isCurrentMonthAndYear = isSameMonth(date, currentDate) && date.getFullYear() === currentDate.getFullYear();

                              return (
                                <div
                                  key={date}
                                  className={`calendar-day ${isEventOnDate(date) ? 'event-day' : ''} ${isSameDay(date, currentDate) ? 'current-day' : ''}`}
                                  style={
                                    isEventOnDate(date)
                                      ? { backgroundColor: '#2ecc70', color: 'white' }
                                      : isSameDay(date, currentDate) && isCurrentMonthAndYear
                                        ? { backgroundColor: 'white', color: '#ff7976' }
                                        : {}
                                  }
                                  onClick={() => handleDateClick(date)}
                                >
                                  {format(date, 'd')}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EventCalander;
